// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Ety7","imageUploader":"EGiftCard_imageUploader__2_5Tj"};